import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import type {PropsFor} from "@khanacademy/wonder-blocks-core";
import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import {semanticColor, spacing} from "@khanacademy/wonder-blocks-tokens";
import type {Typography} from "@khanacademy/wonder-blocks-typography";

import caretDownIcon from "@phosphor-icons/core/bold/caret-down-bold.svg";

interface Props {
    text: string | React.ReactElement<PropsFor<Typography>>;
    hovered: boolean;
    focused: boolean;
}

export default function ToolbarBlockSelect(props: Props): React.ReactElement {
    const {text, hovered, focused} = props;

    return (
        <button
            className={css(styles.opener, (hovered || focused) && styles.hover)}
        >
            <span>{text}</span>
            <PhosphorIcon icon={caretDownIcon} style={styles.icon} />
        </button>
    );
}

const styles = StyleSheet.create({
    opener: {
        minInlineSize: 120,
        maxHeight: spacing.xLarge_32,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: "pointer",
        background: "none",
        border: "2px solid transparent",
        padding: spacing.xxSmall_6,
        borderRadius: spacing.xxxSmall_4,
        font: "inherit",
        fontSize: 15,
        color: semanticColor.core.foreground.neutral.strong,
        overflow: "hidden",
        whiteSpace: "nowrap",
    },
    hover: {
        borderColor: semanticColor.core.border.instructive.default,
        color: semanticColor.core.foreground.instructive.subtle,
        outline: "none",
    },
    icon: {
        marginInlineStart: spacing.small_12,
    },
});
